import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MenuItem, SelectItem } from 'primeng/primeng';
import { Observable } from 'rxjs/Observable';
import { INSTITUCIONAL_DOCUMENTO_SIGLA, MODO_PERSPECTIVA_ITENS_MENU_USUARIO, PERMISSAO_ITENS_MENU_USUARIO } from '../../../app.constants';
import { InstitucionalItensDTO } from '../../shared/dominios/DTO/institucional-itens.DTO';
import { ItemMenu } from '../../shared/dominios/item-menu';
import { CardModel } from '../../shared/models/card.model';
import { PaginaCardsModel } from '../../shared/models/pagina-cards.model';
import { TipoComunicadoModel } from '../../shared/models/tipo-comunicados.model';
import { FuncoesCardMenu } from '../../shared/util/funcaoes-card-menu/funcoes-card-menu';
import { StorafeUtil } from '../../shared/util/storasge.util';

@Component({
  selector: 'app-card-menu-institucional',
  templateUrl: './card-menu-institucional.component.html',
  styleUrls: ['./card-menu-institucional.component.css']
})
export class CardMenuInstitucionalComponent implements OnInit {


  param = `home`

  @BlockUI() blockUi: NgBlockUI;

  paginaCards: Array<PaginaCardsModel> = new Array<PaginaCardsModel>();

  disabled = false;

  itemMenu$: Observable<ItemMenu[]>;


  tiposConsultas: InstitucionalItensDTO[] = [];


  tipoComunicadoModel = new TipoComunicadoModel(null, '');

  tiposComunicadosInformativos: SelectItem[];

  cdCentrus = 629618;


  itensMenu: ItemMenu[] = [];


  isAposentado: Boolean = true;

  items: MenuItem[];
  activeItem: any;


  constructor(
    private funcoesCardMenu: FuncoesCardMenu,
    private router: Router,
    private store: Store<ItemMenu>,
  ) {
    this.itemMenu$ = store.pipe(select('itemMenuLista'));
  }

  ngOnInit() {

    this.getCardsMenu();


    const modoConsultadoUusario = StorafeUtil.recuperarSessionStorage(MODO_PERSPECTIVA_ITENS_MENU_USUARIO);

    const permitirAcessoItensMenuUsuario = StorafeUtil.recuperarSessionStorage(PERMISSAO_ITENS_MENU_USUARIO);
    if (modoConsultadoUusario) { (permitirAcessoItensMenuUsuario) ? (this.disabled = false) : (this.disabled = true) };
  }

  async getCardsMenu() {
    // this.blockUi.start('Carregando...');

    try {
      this.itemMenu$.subscribe((arg) => this.agruparItensMenu(arg));
      this.findItemMenu();
    } catch (error) {
      console.error(error);

    } finally {
      // this.blockUi.stop();
    }
  }


  async findItemMenu() {

    this.itemMenu$
      .subscribe(arg => {
        if (arg.length > 0) {
          const itemPai = arg.find(item1 => item1.sgItemMenu.toLowerCase() === 'institucional'.toLowerCase())


          this.itensMenu = arg.filter(item2 => (item2.itemMenuPai) && (item2.itemMenuPai.idItemMenu === itemPai.idItemMenu));

          if (this.itensMenu.length > 0) { this.agruparItensMenu(this.itensMenu) };
        }

      },
        (error) => {
          // this.toastrService.error(MessageUtil.ERROR_UPDATE_REGISTRO)
        });


  }


  agruparItensMenu(itensMenu: ItemMenu[]) {
    const paginaCards = new PaginaCardsModel();

    this.itensMenu.forEach(element => {
      paginaCards.titulo = 'Institucional';
      // const imagem = 'https://icon-library.com/images/pdf-png-icon/pdf-png-icon-13.jpg';
      const imagem = this.funcoesCardMenu._recuperarImagem(element.imagem);
      paginaCards.cardList.push(new CardModel(element.dsUrl, element.sgItemMenu, element.dsItemMenu, imagem, element.tpTela, element.irNumeracao));
    });
    if (paginaCards.cardList.length > 0) {
      this.paginaCards.push(paginaCards);

      this.paginaCards[0].cardList = this.paginaCards[0].cardList.sort(function (a, b) {
        if (a.descricao > b.descricao) {
          return 1;
        }
        if (a.descricao < b.descricao) {
          return -1;
        }
        return 0;
      });

    }

  }




  direcionar(dadosCards: CardModel): void {

    if (dadosCards.sigla === 'eacd_ar') {
      this.router.navigate([`/institucional/pauta/`, dadosCards.sigla], { skipLocationChange: true });
      return;
    }
    if (dadosCards.sigla === 'eacf_ar') {
      this.router.navigate([`/institucional/pauta/`, dadosCards.sigla], { skipLocationChange: true });
      return;
    }

    this.router.navigateByUrl(`/institucional/institucionalAcessoDocumentos`, { skipLocationChange: true });
    StorafeUtil.gravaSessionStorage(INSTITUCIONAL_DOCUMENTO_SIGLA, { sigla: dadosCards.sigla, descricao: dadosCards.descricao })
  }

}

// institucionalAcessoSistemas"/institucional/institucionalAcessoDocumentos"



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/card-menu/card-menu-institucional/card-menu-institucional.component.ts